"use strict";
// import { rejects } from "assert";
// import { resolve } from "path";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getFormatRes_1 = require("../util/getFormatRes");
var chivy_1 = tslib_1.__importDefault(require("chivy"));
var c = new chivy_1.default("IHAIER-RUNTIME-DEBUGG");
function getLinkUrl(url, options) {
    Object.getOwnPropertyNames(options).forEach(function (index) {
        url = url + "&" + index + "=" + options[index];
    });
    url = url + "&brand_t=ihaier";
    var reg = new RegExp("\\&");
    url = url.replace(reg, "?");
    return new Promise(function (resolve, reject) {
        try {
            window.open(url);
            var myRes = {};
            myRes.success = true;
            resolve(myRes);
        }
        catch (err) {
            reject(err);
        }
    });
}
var globalIhaier2Instance = undefined;
var IHaierDebug = /** @class */ (function () {
    function IHaierDebug() {
        this.initializing = false;
        this.link = {
            openApp: function () {
                var url = "https://applink.feishu.cn/client/op/open?brand_t=ihaier";
                return new Promise(function (resolve, reject) {
                    try {
                        window.open(url);
                        var myRes = {};
                        myRes.success = true;
                        resolve(myRes);
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            },
            openMiniProgram: function (options) {
                var url = "https://applink.feishu.cn/client/mini_program/open";
                return getLinkUrl(url, options);
            },
            openWebApp: function (options) {
                var url = "https://applink.feishu.cn/client/web_app/open";
                return getLinkUrl(url, options);
            },
            openChat: function (options) {
                var url = "https://applink.feishu.cn/client/chat/open";
                return getLinkUrl(url, options);
            },
            openCalendar: function () {
                var url = "https://applink.feishu.cn/client/calendar/open?brand_t=ihaier";
                return new Promise(function (resolve, reject) {
                    try {
                        window.open(url);
                        var myRes = {};
                        myRes.success = true;
                        resolve(myRes);
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            },
            openCalendarView: function (options) {
                var url = "https://applink.feishu.cn/client/calendar/view";
                return getLinkUrl(url, options);
            },
            openCalendarCreate: function (options) {
                var url = "https://applink.feishu.cn/client/calendar/event/create";
                return getLinkUrl(url, options);
            },
            openCalendarAccount: function () {
                var url = "https://applink.feishu.cn/client/calendat/account?brand_t=ihaier";
                return new Promise(function (resolve, reject) {
                    try {
                        window.open(url);
                        var myRes = {};
                        myRes.success = true;
                        resolve(myRes);
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            },
            openTodo: function () {
                var url = "https://applink.feishu.cn/client/todo/open?brand_t=ihaier";
                return new Promise(function (resolve, reject) {
                    try {
                        window.open(url);
                        var myRes = {};
                        myRes.success = true;
                        resolve(myRes);
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            },
            openTodoCreate: function () {
                var url = "https://applink.feishu.cn/client/todo/create?brand_t=ihaier";
                return new Promise(function (resolve, reject) {
                    try {
                        window.open(url);
                        var myRes = {};
                        myRes.success = true;
                        resolve(myRes);
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            },
            openTodoDetail: function (options) {
                var url = "https://applink.feishu.cn/client/todo/detail";
                return getLinkUrl(url, options);
            },
            openTodoView: function (options) {
                var url = "https://applink.feishu.cn/client/todo/view";
                return getLinkUrl(url, options);
            },
            openDocs: function (options) {
                var url = "https://applink.feishu.cn/client/docs/open";
                return getLinkUrl(url, options);
            },
            openBot: function (options) {
                var url = "https://applink.feishu.cn/client/bot/open";
                return getLinkUrl(url, options);
            },
            openSSO: function (options) {
                var url = "https://applink.feishu.cn/client/passport/sso_login";
                return getLinkUrl(url, options);
            },
            openWebView: function (options) {
                var url = "https://applink.feishu.cn/client/web_url/open";
                return getLinkUrl(url, options);
            }
        };
        this.navigationBar = {
            setNavigationBar: function (options) {
                return new Promise(function (resolve) {
                    var myRes = {};
                    myRes.errMsg = "请在iHaier客户端或者APP查看";
                    resolve(myRes);
                });
            },
            onLeftNavigationBarClick: function (func) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            onRightNavigationBarClick: function (func) {
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.contact = {
            chooseContact: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.share = {
            share: function (options) {
                return new Promise(function (resolve) {
                    var myRes = {};
                    myRes.errMsg = "请在iHaier客户端或者APP查看";
                    resolve(myRes);
                });
            },
            bizShare: function (options) {
                return new Promise(function (resolve) {
                    var myRes = {};
                    myRes.errMsg = "请在iHaier客户端或者APP查看";
                    resolve(myRes);
                });
            }
        };
        this.userinfo = {
            getUserInfo: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            enterProfile: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.chat = {
            chooseChat: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            enterChat: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            getChatInfo: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            toggleChat: function (options) {
                c.debug("开始调用api toggleChat");
                return getFormatRes_1.promptUseOnIHaier();
            },
            sendMessageCard: function (options) {
                c.debug("开始调用api sendMessageCard");
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.clipboard = {
            getClipboardData: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            setClipboardData: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.file = {
            docsPicker: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            filePicker: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            saveFile: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            openDocument: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            getFileSystemManager: function () {
                var myFileSystemManager = {};
                myFileSystemManager.readFile = function (options) {
                    return getFormatRes_1.promptUseOnIHaier();
                };
                myFileSystemManager.stat = function (options) {
                    return getFormatRes_1.promptUseOnIHaier();
                };
                return myFileSystemManager;
            }
        };
        this.image = {
            chooseImage: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            compressImage: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            getImageInfo: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            previewImage: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            saveImageToPhotosAlbum: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.video = {
            chooseVideo: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            saveVideoToPhotosAlbum: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            chooseMedia: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api chooseMedia");
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.location = {
            chooseLocation: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            getLocation: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            openLocation: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            startLocationUpdate: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api openLocation");
                return getFormatRes_1.promptUseOnIHaier();
            },
            stopLocationUpdate: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api openLocation");
                return getFormatRes_1.promptUseOnIHaier();
            },
            onLocationChange: function (func) {
                return tslib_1.__awaiter(this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        return [2 /*return*/, getFormatRes_1.promptUseOnIHaier()];
                    });
                });
            }
        };
        this.vibrate = {
            vibrateLong: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            vibrateShort: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.deviceCredential = {
            startDeviceCredential: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.navigation = {
            openSchema: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            close: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            closeWindow: function () {
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.system = {
            getSystemInfo: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            getDeviceID: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用getDeviceID");
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.network = {
            getNetworkType: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            downloadFile: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            getNetworkQualityType: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api getNetworkQualityType");
                return getFormatRes_1.promptUseOnIHaier();
            },
            onNetworkQualityChange: function (func) {
                return tslib_1.__awaiter(this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        return [2 /*return*/, getFormatRes_1.promptUseOnIHaier()];
                    });
                });
            }
        };
        this.setting = {
            getSetting: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            openSetting: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            authorize: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.screenBrightness = {
            getScreenBrightness: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            setScreenBrightness: function (options) {
                return getFormatRes_1.promptUseOnIHaier();
            },
            setKeepScreenOn: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.ui = {
            showToast: function (options) {
                c.debug("开始调用api");
                return getFormatRes_1.promptUseOnIHaier();
            },
            showActionSheet: function (options) {
                c.debug("开始调用api");
                return getFormatRes_1.promptUseOnIHaier();
            },
            showModal: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api showModal");
                return getFormatRes_1.promptUseOnIHaier();
            },
            showPrompt: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api showPrompt");
                return getFormatRes_1.promptUseOnIHaier();
            },
            hideToast: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api hideToast");
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.captureScreen = {
            onUserCaptureScreen: function (func) {
                return tslib_1.__awaiter(this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        return [2 /*return*/, getFormatRes_1.promptUseOnIHaier()];
                    });
                });
            },
            offUserCaptureScreen: function (func) {
                return tslib_1.__awaiter(this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        return [2 /*return*/, getFormatRes_1.promptUseOnIHaier()];
                    });
                });
            }
        };
        this.record = {
            getRecorderManager: function () {
                c.debug("请在iHaier客户端或者APP查看");
            }
        };
        this.verify = {
            startPasswordVerify: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api startPasswordVerify");
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.watermark = {
            checkWatermark: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api checkWatermark");
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.mail = {
            mailto: function (options) {
                c.debug("开始调用api mailto");
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.wifi = {
            getConnectedWifi: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            getWifiStatus: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            getWifiList: function (options) {
                if (options === void 0) { options = {}; }
                return getFormatRes_1.promptUseOnIHaier();
            },
            onGetWifiList: function (func) {
                var myRes = {};
                myRes.errMsg = "请在iHaier客户端或者APP查看";
                func(myRes);
                return myRes;
            },
            offGetWifiList: function (func) {
                var myRes = {};
                func(myRes);
                myRes.errMsg = "请在iHaier客户端或者APP查看";
                return myRes;
            }
        };
        this.accelerometer = {
            startAccelerometer: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api startAccelerometer");
                return getFormatRes_1.promptUseOnIHaier();
            },
            stopAccelerometer: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api stopAccelerometer");
                return getFormatRes_1.promptUseOnIHaier();
            },
            onAccelerometerChange: function (func) {
                c.debug("开始调用api onAccelerometerChange");
                var myRes = {};
                myRes.errMsg = "请在iHaier客户端或者APP查看";
                func(myRes);
            }
        };
        this.compass = {
            startCompass: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api startCompass");
                return getFormatRes_1.promptUseOnIHaier();
            },
            stopCompass: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api stopCompass");
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.bluetooth = {
            closeBluetoothAdapter: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api closeBluetoothAdapter");
                return getFormatRes_1.promptUseOnIHaier();
            },
            getBluetoothAdapterState: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api getBluetoothAdapterState");
                return getFormatRes_1.promptUseOnIHaier();
            },
            getBluetoothDevices: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api getBluetoothDevices");
                return getFormatRes_1.promptUseOnIHaier();
            },
            onBluetoothAdapterStateChange: function (func) {
                c.debug("开始调用api");
                return getFormatRes_1.promptUseOnIHaier();
            },
            onBluetoothDeviceFound: function (options) {
                c.debug("开始调用api");
                return getFormatRes_1.promptUseOnIHaier();
            },
            startBluetoothDevicesDiscovery: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api");
                return getFormatRes_1.promptUseOnIHaier();
            },
            openBluetoothAdapter: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api openBluetoothAdapter");
                return getFormatRes_1.promptUseOnIHaier();
            },
            stopBluetoothDevicesDiscovery: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api stopBluetoothDevicesDiscovery");
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        this.beacon = {
            startBeaconDiscovery: function (options) {
                c.debug("开始调用api startBeaconDiscovery");
                return getFormatRes_1.promptUseOnIHaier();
            },
            closeBluetoothAdapter: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api closeBluetoothAdapter");
                return getFormatRes_1.promptUseOnIHaier();
            },
            getBeacons: function (options) {
                if (options === void 0) { options = {}; }
                c.debug("开始调用api getBeacons");
                return getFormatRes_1.promptUseOnIHaier();
            },
            onBeaconUpdate: function (func) {
                var myRes = {};
                myRes.errMsg = "请在iHaier客户端或者APP查看";
                func(myRes);
            },
            offBeaconUpdate: function (func) {
                var myRes = {};
                myRes.errMsg = "请在iHaier客户端或者APP查看";
                func(myRes);
            },
            onBeaconServiceChange: function (func) {
                var myRes = {};
                myRes.errMsg = "请在iHaier客户端或者APP查看";
                func(myRes);
            },
            offBeaconServiceChange: function (func) {
                var myRes = {};
                myRes.errMsg = "请在iHaier客户端或者APP查看";
                func(myRes);
            }
        };
        this.phone = {
            makePhoneCall: function (options) {
                c.debug("开始调用api makePhoneCall");
                return getFormatRes_1.promptUseOnIHaier();
            }
        };
        if (globalIhaier2Instance) {
            return globalIhaier2Instance;
        }
        globalIhaier2Instance = this;
    }
    IHaierDebug.prototype.initialize = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.initializing)
                    return [2 /*return*/];
                //@ts-ignore
                this.scanCode = this.scanCode2;
                this.initializing = true;
                return [2 /*return*/];
            });
        });
    };
    IHaierDebug.prototype.closeBluetoothAdapter = function () {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // applyTenantAppScope: IRuntimeAPI;
    // // checkLocalFaceVerify: IRuntimeAPI;
    // // chooseChat: IRuntimeAPI;
    // // chooseContact: IRuntimeAPI;
    IHaierDebug.prototype.disconnectBLEDevice = function (options) {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // enterBot: IRuntimeAPI;
    // // enterChat: IRuntimeAPI;
    // // enterProfile: IRuntimeAPI;
    IHaierDebug.prototype.getBLEDeviceCharacteristics = function (options) {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.getBLEDeviceServices = function (options) {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // getBlockActionSourceDetail: IRuntimeAPI;
    IHaierDebug.prototype.getBluetoothAdapterState = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.getBluetoothDevices = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // getConnectedBluetoothDevices: IRuntimeAPI;
    // /**
    //  *
    //  */
    // // getEnvVariable: IRuntimeAPI;
    // // getExtConfig: IRuntimeAPI;
    // // getHostLaunchQuery: IRuntimeAPI;
    IHaierDebug.prototype.getNFCAdapter = function () {
        // const NFCAdapter: any = this.feishu.tt.getNFCAdapter();
        // const NfcA: any = NFCAdapter.getNfcA();
        var myNFCAdapter = {};
        var myNfcA = {};
        myNfcA.connect = function (options) {
            if (options === void 0) { options = {}; }
            return getFormatRes_1.promptUseOnIHaier();
        };
        myNfcA.close = function (options) {
            return getFormatRes_1.promptUseOnIHaier();
        };
        myNfcA.getSak = function (options) {
            return getFormatRes_1.promptUseOnIHaier();
        };
        myNfcA.getAtqa = function (options) {
            return getFormatRes_1.promptUseOnIHaier();
        };
        myNfcA.getMaxTransceiveLength = function (options) {
            return getFormatRes_1.promptUseOnIHaier();
        };
        myNfcA.transceive = function (options) {
            return getFormatRes_1.promptUseOnIHaier();
        };
        myNfcA.setTimeout = function (options) {
            return getFormatRes_1.promptUseOnIHaier();
        };
        myNFCAdapter.getNfcA = function () { return myNfcA; };
        return myNFCAdapter;
    };
    // // getRecorderManager: IRuntimeAPI;
    // // getSavedFileList: IRuntimeAPI;
    // // getTenantAppScopes: IRuntimeAPI;
    // // getTriggerContext: IRuntimeAPI;
    IHaierDebug.prototype.getUserInfo = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // getUserInfoEx: IRuntimeAPI;
    IHaierDebug.prototype.hideToast = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.mailto = function (options) {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.notifyBLECharacteristicValueChange = function (options) {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // offBLECharacteristicValueChange: IRuntimeAPI;
    // // offBLEConnectionStateChange: IRuntimeAPI;
    // // offBluetoothAdapterStateChange: IRuntimeAPI;
    // // offBluetoothDeviceFound: IRuntimeAPI;
    // // offChatBadgeChange: IRuntimeAPI;
    IHaierDebug.prototype.offUserCaptureScreen = function () {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // offWatermarkChange: IRuntimeAPI;
    IHaierDebug.prototype.onAccelerometerChange = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.onBLECharacteristicValueChange = function (options) {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // onBLEConnectionStateChange: IRuntimeAPI;
    IHaierDebug.prototype.onBluetoothAdapterStateChange = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.onBluetoothDeviceFound = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // onChatBadgeChange: IRuntimeAPI;
    // // onCompassChange: IRuntimeAPI;
    IHaierDebug.prototype.onUserCaptureScreen = function () {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // onWatermarkChange: IRuntimeAPI;
    IHaierDebug.prototype.openBluetoothAdapter = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // opmonitor: IRuntimeAPI;
    // // prepareLocalFaceVerify: IRuntimeAPI;
    IHaierDebug.prototype.readBLECharacteristicValue = function (options) {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // removeSavedFile: IRuntimeAPI;
    IHaierDebug.prototype.scanCode2 = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // sendMessageCard: IRuntimeAPI;
    // // setAuthenticationInfo: IRuntimeAPI;
    // // setBLEMTU: IRuntimeAPI;
    // // share: IRuntimeAPI;
    IHaierDebug.prototype.showActionSheet = function (options) {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.showModal = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.showPrompt = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.showToast = function (options) {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.startAccelerometer = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    /**
     *
     * @param options
     * Todo
     */
    IHaierDebug.prototype.startBluetoothDevicesDiscovery = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.startCompass = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    // // startFaceIdentify: IRuntimeAPI;
    // // startFaceVerify: IRuntimeAPI;
    // // startLocalFaceVerify: IRuntimeAPI;
    IHaierDebug.prototype.startPasswordVerify = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.stopAccelerometer = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.stopBluetoothDevicesDiscovery = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.stopCompass = function (options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    IHaierDebug.prototype.writeBLECharacteristicValue = function (options) {
        return new Promise(function (resolve) {
            var myRes = {};
            myRes.errMsg = "请在iHaier客户端或者APP查看";
            resolve(myRes);
        });
    };
    return IHaierDebug;
}());
exports.default = IHaierDebug;
//# sourceMappingURL=data:application/json;base64,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